import { render, staticRenderFns } from "./TransactionItemsRow.vue?vue&type=template&id=fdeac33e&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./TransactionItemsRow.vue?vue&type=script&lang=js"
export * from "./TransactionItemsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeac33e",
  null
  
)

export default component.exports